export const ON_WIKI_LINK_REMOVE = 'wiki-link/remove'
export const ON_DOC_LINK_REMOVE = 'doc-link/remove'
export const ON_WORK_ITEM_LINK_REMOVE = 'work-item-link/remove'
